import { combineReducers } from 'redux';
import AuthReducer from './auth-reducer';

import UserReducer from './user-reducer';

import updateInstitutionTableReducer from './institution-table/update-institution-table-reducer';

const rootReducer = combineReducers({
  auth: AuthReducer,
  user: UserReducer,
  institutionTable: combineReducers({
    updateInstitutionTable: updateInstitutionTableReducer,
  }),
});

export default rootReducer;
